import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Aed = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Aed' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,8.4 C2,4 5,3 7,3 C9,3 11,5 12,6.5 C13,5 15,3 17,3 C19,3 22,4 22,8.4 C22,15 12,21 12,21 C12,21 2,15 2,8.4 Z M12,6 C11.5,5.5 10,10 10,10 L12,10 L12,12.5 L14,9 L12,9 C12,9 13,3 17,3 C13,3 12,6 12,6 Z' />
  </StyledIcon>
);
